import React, { useRef, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { anodum } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import getProhibitedHtmlTagAnnotations from 'src/js/modules/common/helpers/get-prohibited-html-tag-annotations';
import fieldNames from '../constants/field-names';
import validators from '../validators';

const { CodeEditorField } = designSystem;

const IframeCodeControl = ({ control, onChange }) => {
  const codeErrorMessage = useRef(null);

  const name = fieldNames.IFRAME_CODE;
  const rules = useMemo(
    () => ({
      validate: (code) => {
        const validator = validators.createIframeCodeValidator(codeErrorMessage.current);

        return validator(code);
      },
    }),
    []
  );

  const handleChange = (value) => {
    onChange(value);
  };

  const handleCodePaste = (pasteAction) => {
    const doc = anodum.parseDocumentFromString(pasteAction.text);
    const iframe = doc.body.querySelector('iframe');

    if (iframe) {
      // eslint-disable-next-line no-param-reassign
      pasteAction.text = iframe.outerHTML;
    }
  };

  const handleEditorError = (editorError) => {
    const previousError = codeErrorMessage.current;
    const currentError = editorError || null;

    codeErrorMessage.current = currentError;

    if (previousError !== currentError) {
      onChange();
    }
  };

  const onValidate = useCallback(
    ({ value, session }) => getProhibitedHtmlTagAnnotations(value, session),
    []
  );

  return (
    <div>
      <CodeEditorField
        name={name}
        control={control}
        rules={rules}
        onChange={handleChange}
        onPaste={handleCodePaste}
        onEditorError={handleEditorError}
        onValidate={onValidate}
      />
    </div>
  );
};

IframeCodeControl.propTypes = {
  control: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default IframeCodeControl;
